const header = () => {
  // Menu Mobile Toggle
  const menuToggle = document.querySelector('.menu-toggle');
  const menuMobile = document.getElementById('menuMobile');
  const menuClose = document.getElementById('menuClose');
  const menuOverlay = document.querySelector('.menu-overlay');

  if (menuToggle && menuMobile) {
    // Open menu
    menuToggle.addEventListener('click', function (e) {
      e.preventDefault();
      menuMobile.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent body scroll
    });

    // Close menu
    function closeMenu() {
      menuMobile.classList.remove('active');
      document.body.style.overflow = ''; // Restore body scroll
    }

    if (menuClose) {
      menuClose.addEventListener('click', closeMenu);
    }

    if (menuOverlay) {
      menuOverlay.addEventListener('click', closeMenu);
    }

    // Close menu on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menuMobile.classList.contains('active')) {
        closeMenu();
      }
    });

    // Close menu when clicking on menu items
    const menuItems = document.querySelectorAll('.menu-item');
    menuItems.forEach(item => {
      item.addEventListener('click', function () {
        setTimeout(closeMenu, 100); // Small delay for better UX
      });
    });
  }

  // Header hide/show on scroll
  const headerEl = document.querySelector('header');

  if (headerEl) {
    let lastScrollY = window.scrollY;
    let ticking = false;
    const SCROLL_DIRECTION_THRESHOLD = 6;
    const TOP_RESET_THRESHOLD = 20;

    const updateHeaderState = () => {
      const currentY = window.scrollY;

      if (currentY <= TOP_RESET_THRESHOLD) {
        headerEl.classList.remove('header--hidden', 'header--scrolled');
        lastScrollY = currentY;
        ticking = false;
        return;
      }

      headerEl.classList.add('header--scrolled');

      if (currentY > lastScrollY + SCROLL_DIRECTION_THRESHOLD) {
        headerEl.classList.add('header--hidden');
      } else if (currentY < lastScrollY - SCROLL_DIRECTION_THRESHOLD) {
        headerEl.classList.remove('header--hidden');
      }

      lastScrollY = currentY;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderState);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
  }
}

module.exports = header;
